import Vue from 'vue'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import VueAWN from "vue-awesome-notifications"
Vue.use(VueAWN);
require("vue-awesome-notifications/dist/styles/style.css")
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

import { messages } from '../static/i18n/index.js'

const i18n = new VueI18n({
  locale: 'it',
  fallbackLocale: 'it',
  messages
})

import App from './App.vue'
import Vuetify from 'vuetify'
Vue.use(Vuetify, {
  theme: {
    obloyellow: '#ad7137',
    // obloblue: '#124751',
    // success: '#124751',
    obloblue: '#006064',  // cyan darken-4
    success: '#006064',
  },
  options: {
    customProperties: true
  }
});

import 'vuetify/dist/vuetify.min.css'
import router from './router'
import store from './store/index'

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
